// Orders are recorded in UTC (see order_service.place_order), but the bakery
// runs on Eastern time. The stored date and time are two halves of one instant,
// so they have to be converted together: an order placed at 9pm Eastern is
// stored as 01:00 the *next* day in UTC, and converting the time alone would
// leave it showing tomorrow's date.

const EASTERN = 'America/New_York';

const easternDate = new Intl.DateTimeFormat('en-US', {
  timeZone: EASTERN,
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

const easternTime = new Intl.DateTimeFormat('en-US', {
  timeZone: EASTERN,
  hour: 'numeric',
  minute: '2-digit',
  timeZoneName: 'short',
});

// Combines a stored UTC date ("2026-08-09") and time ("01:30:00") into the
// instant they describe, or null when either is missing or unparseable.
export const toUtcInstant = (orderDate, orderTime) => {
  const [year, month, day] = String(orderDate ?? '').split('-').map(Number);
  const [hour, minute, second] = String(orderTime ?? '').split(':').map(Number);
  if (!year || !month || !day) return null;
  if (!Number.isFinite(hour) || !Number.isFinite(minute)) return null;

  const instant = new Date(
    Date.UTC(year, month - 1, day, hour, minute, Number.isFinite(second) ? second : 0)
  );
  return Number.isNaN(instant.getTime()) ? null : instant;
};

export const formatOrderDate = (orderDate, orderTime) => {
  const instant = toUtcInstant(orderDate, orderTime);
  // Without a usable time the date can't be shifted safely, so show it as stored.
  if (!instant) return orderDate || '—';
  return easternDate.format(instant);
};

export const formatOrderTime = (orderDate, orderTime) => {
  const instant = toUtcInstant(orderDate, orderTime);
  if (!instant) return orderTime || '—';
  return easternTime.format(instant);
};
